import {Model} from "@vuex-orm/core";

export default class WebsiteProductWebsiteCategory extends Model {

    static entity = 'WebsiteProductWebsiteCategory';

    static primaryKey = ['website_product_id', 'website_category_id'];

    static fields () {
        return {
            website_product_id: this.number(null).nullable(),
            website_category_id: this.number(null).nullable(),
        }
    }
}
